export const isFullArray = (maybeArray) =>
  Array.isArray(maybeArray) && maybeArray?.length > 0;

export const isFullObject = (maybeObject) =>
  typeof maybeObject === 'object' && Object.keys(maybeObject)?.length > 0;
